// extracted by mini-css-extract-plugin
module.exports = {"explanations":"br_h1","explanations__item":"br_h2","explanations__title":"br_h3","explanations__text":"br_h4"};